module.exports = __webpack_public_path__ + "img/ic-add-project.43613289.svg";